import { useState, useCallback, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import CustomiseReport from "../../components/CustomiseReport";
import PortalPopup from "../../components/PortalPopup";
import ExportModalImage from "../../components/ExportModalImage";
import LogoutConfirmation from "../../components/LogoutConfirmation";
import NavigationPanel from "../../components/NavigationPanel";
import CTAs from "../../components/CTAs";
import {
  PieChart,
  Pie,
  Cell,
  Bar,
  BarChart,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Label,
  defs,
  linearGradient,
  stop,
} from "recharts";
import Footer from "../../components/Footer";

const OutcomesAndCostsPage_5 = () => {
  const navigate = useNavigate();
  const [isCustomiseReportOpen, setCustomiseReportOpen] = useState(false);
  const [isExportModalImageOpen, setExportModalImageOpen] = useState(false);
  const [isLogoutConfirmationOpen, setLogoutConfirmationOpen] = useState(false);
  const [isExportModalImage1Open, setExportModalImage1Open] = useState(false);

  const onClickOutcomeUpdate = useCallback(() => {
    navigate("/outcome&cost");
  }, [navigate]);

  const onClickCostImplication = useCallback(() => {
    navigate("/outcome&cost2");
  }, [navigate]);

  const onClickJudgementPhase = useCallback(() => {
    navigate("/outcome&cost3");
  }, [navigate]);

  const onClickClientCommunication = useCallback(() => {
    navigate("/outcome&cost4");
  }, [navigate]);

  const openCustomiseReport = useCallback(() => {
    setCustomiseReportOpen(true);
  }, []);

  const closeCustomiseReport = useCallback(() => {
    setCustomiseReportOpen(false);
  }, []);

  const openExportModalImage = useCallback(() => {
    setExportModalImageOpen(true);
  }, []);

  const closeExportModalImage = useCallback(() => {
    setExportModalImageOpen(false);
  }, []);

  const closeLogoutConfirmation = useCallback(() => {
    setLogoutConfirmationOpen(false);
  }, []);

  const openExportModalImage1 = useCallback(() => {
    setExportModalImage1Open(true);
  }, []);

  const closeExportModalImage1 = useCallback(() => {
    setExportModalImage1Open(false);
  }, []);

  const navItems = [
    {
      text: "Debt collection",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "",
      icon: "assets/arrow-down.svg",
    },

    {
      text: "Outcomes & costs",
      bgColor: "bg-primary-primary-50",
      textColor: "text-neutrals-neutral-900",
      hoverBgColor: "bg-primary-primary-50",
      hoverTextColor: "text-neutrals-neutral-900",
      path: "",
      icon: "",
    },

    {
      text: "AI indicators",
      bgColor: "bg-neutrals-neutral-50",
      textColor: "text-neutrals-neutral-300",
      hoverBgColor: "bg-neutrals-neutral-50",
      hoverTextColor: "text-primary-primary-500",
      path: "/ai1",
      icon: "",
    },
  ];

  // Colors for successful and unsuccessful
  const CATEGORY_COLORS = {
    Successful: "#28a745", // Green
    Unsuccessful: "#dc3545", // Red
  };

  // Function to fetch real-time data for Pie Chart
  const fetchPieChartData = () => {
    let successful = Math.random();
    let unsuccessful = Math.random();

    // Normalize to 100%
    let total = successful + unsuccessful;

    return [
      {
        name: "Successful",
        value: parseFloat(((successful / total) * 100).toFixed(2)),
      },
      {
        name: "Unsuccessful",
        value: parseFloat(((unsuccessful / total) * 100).toFixed(2)),
      },
    ];
  };

  const [data2, setData2] = useState(fetchPieChartData());

  useEffect(() => {
    const interval = setInterval(() => {
      setData2(fetchPieChartData());
    }, 5000); // Update every 5 seconds

    return () => clearInterval(interval);
  }, []);

  const data = [
    { day: "Mon", pattern1: 10, pattern2: 20, pattern3: 15 },
    { day: "Tue", pattern1: 15, pattern2: 25, pattern3: 10 },
    { day: "Wed", pattern1: 20, pattern2: 15, pattern3: 30 },
    { day: "Thu", pattern1: 25, pattern2: 10, pattern3: 20 },
    { day: "Fri", pattern1: 30, pattern2: 20, pattern3: 25 },
    { day: "Sat", pattern1: 35, pattern2: 30, pattern3: 40 },
    { day: "Sun", pattern1: 40, pattern2: 25, pattern3: 35 },
  ];

  const fetchRealTimeData = () => {
    // Here, replace this with your real-time API call
    return ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day) => {
      let category1 = Math.random();
      let category2 = Math.random();
      let category3 = Math.random();

      // Get total sum
      let total = category1 + category2 + category3;

      // Normalize so the sum equals 100%
      return {
        day,
        category1: (category1 / total) * 100,
        category2: (category2 / total) * 100,
        category3: (category3 / total) * 100,
      };
    });
  };

  const [data1, setData] = useState(fetchRealTimeData());

  useEffect(() => {
    const interval = setInterval(() => {
      const newData = fetchRealTimeData();
      setData(newData); // Update the data
    }, 5000); // Fetch every 5 seconds

    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  return (
    <>
      <div className="w-full relative bg-neutrals-neutral-50 min-h-screen overflow-visible text-left text-base text-neutrals-neutral-900 font-open-sans-ff-body-strong box-border">
        {/* Navigation Panel */}
        <NavigationPanel navItems={navItems} />

        {/* Main */}
        <div className="w-full absolute top-[136px] flex flex-col items-start justify-start gap-6 text-neutrals-neutral-900 px-4 md:px-4 lg:px-24 box-border">
          <b className="self-stretch relative text-9xl">{`Outcomes & costs`}</b>

          {/* Tabs */}
          <div className="flex flex-row items-start justify-start gap-6 text-neutrals-neutral-300">
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickOutcomeUpdate}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Outcome updates</div>
              </div>
            </div>
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickCostImplication}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Cost implications</div>
              </div>
            </div>
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickJudgementPhase}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">Judgement phase</div>
              </div>
            </div>
            <div
              className="bg-neutrals-neutral-50 h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 box-border cursor-pointer"
              onClick={onClickClientCommunication}
            >
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">
                  Client communication
                </div>
              </div>
            </div>
            <div className="bg-neutrals-neutral-50 box-border h-[41px] flex flex-row items-center justify-center pt-0 px-1 pb-3 text-primary-primary-500 border-b-[2px] border-solid border-primary-primary-500">
              <div className="flex flex-row items-center justify-center">
                <div className="relative font-semibold">{`Reporting & analytics`}</div>
              </div>
            </div>
          </div>
          <div className="self-stretch flex flex-col items-start justify-start gap-8">
            <div className="self-stretch flex flex-col items-start justify-start gap-8">
              <div className="self-stretch grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-center justify-start gap-6">
                {/* Block 1 */}
                <div className="w-full shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start p-6 gap-6">
                  <div className="self-stretch flex flex-row items-center justify-between gap-0">
                    <div className="relative font-semibold">Recovery rates</div>
                    <img
                      className="w-5 relative h-5 overflow-hidden shrink-0"
                      alt=""
                      src="assets/more-vert.svg"
                    />
                  </div>
                  <div className="self-stretch h-20 flex flex-col items-start justify-between gap-0 text-13xl">
                    <b className="relative">75%</b>
                    <div className="flex flex-row items-center justify-start gap-1 text-sm text-green-600">
                      <div className="flex flex-row items-center justify-start gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            stroke="#43934c"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1.5"
                            d="M18.07 9.57L12 3.5 5.93 9.57M12 20.5V3.67"
                          ></path>
                        </svg>
                        <div className="relative">20%</div>
                      </div>
                      <div className="relative font-semibold text-neutrals-neutral-300">
                        vs last month
                      </div>
                    </div>
                  </div>
                </div>
                {/* Block 2 */}
                <div className="w-full shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start p-6 gap-6">
                  <div className="self-stretch flex flex-row items-center justify-between gap-0">
                    <div className="relative font-semibold">Response time</div>
                    <img
                      className="w-5 relative h-5 overflow-hidden shrink-0"
                      alt=""
                      src="assets/more-vert.svg"
                    />
                  </div>
                  <div className="self-stretch h-20 flex flex-col items-start justify-between gap-0 text-13xl">
                    <b className="relative">2 days</b>
                    <div className="flex flex-row items-center justify-start gap-1 text-sm text-green-600">
                      <div className="flex flex-row items-center justify-start gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            stroke="#43934c"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1.5"
                            d="M18.07 9.57L12 3.5 5.93 9.57M12 20.5V3.67"
                          ></path>
                        </svg>
                        <div className="relative">40%</div>
                      </div>
                      <div className="relative font-semibold text-neutrals-neutral-300">
                        vs last month
                      </div>
                    </div>
                  </div>
                </div>
                {/* Block 3 */}
                <div className="w-full shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start justify-start p-6 gap-6">
                  <div className="self-stretch flex flex-row items-center justify-between gap-0">
                    <div className="relative font-semibold">Total claims</div>
                    <img
                      className="w-5 relative h-5 overflow-hidden shrink-0"
                      alt=""
                      src="assets/more-vert.svg"
                    />
                  </div>
                  <div className="self-stretch h-20 flex flex-col items-start justify-between gap-0 text-13xl">
                    <b className="relative">100</b>
                    <div className="flex flex-row items-center justify-start gap-1 text-sm text-green-600">
                      <div className="flex flex-row items-center justify-start gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            stroke="#43934c"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                            stroke-width="1.5"
                            d="M18.07 9.57L12 3.5 5.93 9.57M12 20.5V3.67"
                          ></path>
                        </svg>
                        <div className="relative">15%</div>
                      </div>
                      <div className="relative font-semibold text-neutrals-neutral-300">
                        vs last month
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Multi-Line Graph */}
              <div className="w-full shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-col items-start justify-start p-6 gap-[24px] text-sm border-[1px] border-solid border-neutrals-neutral-100 box-border">
                <div className="w-full flex flex-row items-center justify-between text-lg">
                  <div className="relative font-semibold">
                    Defence pattern trends
                  </div>
                  <CTAs
                    type="Ghostbtn"
                    text="Export"
                    textColor="text-neutrals-neutral-900"
                    bgColor="bg-neutrals-neutral-50"
                    borderColor="border-neutrals-neutral-100"
                    icon={
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          stroke="#2d404e"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.5"
                          d="M16.44 8.9c3.6.31 5.07 2.16 5.07 6.21v.13c0 4.47-1.79 6.26-6.26 6.26H8.74c-4.47 0-6.26-1.79-6.26-6.26v-.13c0-4.02 1.45-5.87 4.99-6.2M12 15V3.62M15.35 5.85L12 2.5 8.65 5.85"
                        ></path>
                      </svg>
                    }
                    position="relative"
                    onClick={openExportModalImage1}
                  />
                </div>
                <div className="w-full flex flex-col items-start justify-start text-neutrals-neutral-300">
                  <div className="w-full flex flex-col items-end justify-start gap-[24px]">
                    <div className="flex flex-row items-start justify-start gap-[10px]">
                      <div className="flex flex-row items-center justify-start gap-[6px]">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-500 h-2" />
                        <div className="relative">Pattern 1</div>
                      </div>
                      <div className="flex flex-row items-center justify-start gap-[6px]">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-300 h-2" />
                        <div className="relative">Pattern 2</div>
                      </div>
                      <div className="flex flex-row items-center justify-start gap-[6px]">
                        <div className="w-2 relative rounded-[50%] bg-primary-primary-700 h-2" />
                        <div className="relative">Pattern 3</div>
                      </div>
                    </div>

                    {/* Line graph */}
                    <div className="w-full h-[292px]">
                      <ResponsiveContainer width="100%" height="100%">
                        <LineChart
                          data={data}
                          margin={{
                            top: 20,
                            right: 30,
                            left: 30,
                            bottom: 15,
                          }}
                        >
                          <defs>
                            <linearGradient
                              id="gradientPattern1"
                              x1="0"
                              y1="0"
                              x2="1"
                              y2="0"
                            >
                              <stop offset="0%" stopColor="#487C94" />
                              <stop offset="100%" stopColor="#74B3CE" />
                            </linearGradient>
                          </defs>
                          <CartesianGrid
                            strokeDasharray="3 3"
                            horizontal={true}
                            vertical={true}
                          />
                          <XAxis dataKey="day">
                            <Label
                              value="Days"
                              position="insideBottom"
                              offset={-10}
                              style={{
                                textAnchor: "middle",
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            />
                          </XAxis>
                          <YAxis>
                            <Label
                              value="Response time"
                              angle={-90}
                              position="insideLeft"
                              offset={-10}
                              style={{
                                textAnchor: "middle",
                                fontSize: "14px",
                                fontWeight: "bold",
                                textColor: "#000000",
                              }}
                            />
                          </YAxis>
                          <Tooltip />
                          <legend />

                          {/* Lines for each pattern */}
                          <Line
                            type="monotone"
                            dataKey="pattern1"
                            stroke="#487C94"
                            strokeWidth={2}
                          />
                          <Line
                            type="monotone"
                            dataKey="pattern2"
                            stroke="#DE5D5F"
                            strokeWidth={2}
                          />
                          <Line
                            type="monotone"
                            dataKey="pattern3"
                            stroke="#6FB0D4"
                            strokeWidth={2}
                          />
                        </LineChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
                <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-start">
                  <div className="rounded-tl-3xs rounded-tr-none rounded-br-none rounded-bl-3xs bg-column-bg flex flex-row items-center justify-center py-2 px-4 border-[1px] border-solid border-neutrals-neutral-100">
                    <div className="relative font-semibold">Daily</div>
                  </div>
                  <div className="flex flex-row items-center justify-center py-2 px-4 border-r-[1px] border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100">
                    <div className="relative font-semibold">Weekly</div>
                  </div>
                  <div className="flex flex-row items-center justify-center py-2 px-4 border-r-[1px] border-t-[1px] border-b-[1px] border-solid border-neutrals-neutral-100">
                    <div className="relative font-semibold">Monthly</div>
                  </div>
                  <div className="rounded-tl-none rounded-tr-3xs rounded-br-3xs rounded-bl-none flex flex-row items-center justify-center py-2 px-4 border-t-[1px] border-solid border-neutrals-neutral-100 border-r-[1px] border-b-[1px]">
                    <div className="flex flex-row items-center justify-center gap-[6px]">
                      <img
                        className="w-4 relative h-4"
                        alt=""
                        src="assets/add.svg"
                      />
                      <div className="relative font-semibold">Custom</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pie chart */}
              <div className="self-stretch flex flex-row items-center justify-start gap-6 text-lg">
                <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border h-[463px] flex flex-col items-start justify-start p-6 gap-[24px] text-lg border-[1px] border-solid border-neutrals-neutral-100">
                  <div className="w-[404px] box-border flex flex-row items-center justify-between pt-0 px-0 pb-5 border-b-[1px] border-solid border-neutrals-neutral-100">
                    <div className="relative font-semibold">Claim status</div>
                    <img
                      className="w-5 relative h-5 overflow-hidden shrink-0"
                      alt=""
                      src="assets/more-vert.svg"
                    />
                  </div>
                  <div className="w-full flex flex-row items-start justify-start gap-[24px] text-sm">
                    <div className="w-full h-[280px]">
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                          <Pie
                            data={data2}
                            dataKey="value"
                            nameKey="name"
                            cx="50%"
                            cy="50%"
                            outerRadius="80%"
                            label={({ name, percent }) =>
                              `${name}: ${(percent * 100).toFixed(2)}%`
                            }
                            isAnimationActive={true}
                          >
                            {data2.map((entry, index) => {
                              <Cell
                                key={`cell-${index}`}
                                fill={CATEGORY_COLORS[entry.name] || "#C2C2C2"}
                              />;
                            })}
                          </Pie>
                          <Tooltip
                            formatter={(value) => `${value.toFixed(2)}%`}
                          />
                          <Legend
                            layout="vertical"
                            align="right"
                            verticalAlign="middle"
                          />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>

                    {/* Legend */}
                    <div className="flex flex-col items-start justify-start gap-[6px]">
                      {data.map((entry, index) => {
                        <div
                          key={index}
                          className="flex flex-row items-center justify-start gap-[6px]"
                        >
                          <div
                            className="w-3 h-3 rounded-full"
                            style={{
                              backgroundColor:
                                CATEGORY_COLORS[entry.name] || "#c5c5c5",
                            }}
                          />
                          <div className="text-sm">
                            {entry.name}: {entry.value}%
                          </div>
                        </div>;
                      })}
                    </div>
                  </div>
                </div>

                {/* Stacked bar chart */}
                <div className="w-full shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border h-[463px] flex flex-col items-start justify-between p-6 text-sm border-[1px] border-solid border-neutrals-neutral-100">
                  <div className="self-stretch flex flex-row items-center justify-between text-lg">
                    <div className="relative font-semibold">
                      Solicitor and time period
                    </div>
                    <CTAs
                      type="Ghostbtn"
                      text="Export"
                      textColor="text-neutrals-neutral-900"
                      bgColor="bg-neutrals-neutral-50"
                      borderColor="border-neutrals-neutral-100"
                      icon={
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            stroke="#2d404e"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                            d="M16.44 8.9c3.6.31 5.07 2.16 5.07 6.21v.13c0 4.47-1.79 6.26-6.26 6.26H8.74c-4.47 0-6.26-1.79-6.26-6.26v-.13c0-4.02 1.45-5.87 4.99-6.2M12 15V3.62M15.35 5.85L12 2.5 8.65 5.85"
                          ></path>
                        </svg>
                      }
                      position="relative"
                      onClick={openExportModalImage}
                    />
                  </div>

                  {/* Filter */}
                  <div className="shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 flex flex-row items-center justify-start border-[1px] border-solid border-neutrals-neutral-100">
                    <div className="flex flex-row items-center justify-center py-2 px-4 border-r-[1px] border-solid border-neutrals-neutral-100">
                      <div className="relative font-semibold">12 months</div>
                    </div>
                    <div className="flex flex-row items-center justify-center py-2 px-4 border-r-[1px] border-solid border-neutrals-neutral-100">
                      <div className="relative font-semibold">30 days</div>
                    </div>
                    <div className="bg-column-bg flex flex-row items-center justify-center py-2 px-4 border-solid border-neutrals-neutral-100 border-r-[1px]">
                      <div className="relative font-semibold">7 days</div>
                    </div>
                    <div className="flex flex-row items-center justify-center py-2 px-4">
                      <div className="flex flex-row items-center justify-center gap-[6px]">
                        <img
                          className="w-4 relative h-4"
                          alt=""
                          src="assets/add.svg"
                        />
                        <div className="relative font-semibold">Custom</div>
                      </div>
                    </div>
                  </div>

                  {/* Legend */}
                  <div className="self-stretch h-[292px] flex flex-col items-start justify-between text-neutrals-neutral-300">
                    <div style={{ width: "100%", height: 300 }}>
                      <ResponsiveContainer>
                        <BarChart data={data1}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="day" />
                          <YAxis domain={[0, 100]}>
                            <Label
                              value="Accuracy percentage"
                              angle={-90}
                              position="insideLeft"
                              offset={0}
                              style={{
                                textAnchor: "middle",
                                fontSize: "14px",
                                fontWeight: "bold",
                              }}
                            />
                          </YAxis>
                          <Tooltip />
                          <Legend />
                          <Bar dataKey="category1" stackId="a" fill="#68B7DC" />
                          <Bar dataKey="category2" stackId="a" fill="#6872DC" />
                          <Bar dataKey="category3" stackId="a" fill="#A368DC" />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Reorts */}
            <div className="self-stretch flex flex-col items-start justify-start gap-[24px] text-lg">
              <div className="w-full box-border flex flex-row items-center justify-start pt-0 px-0 pb-6 border-b-[1px] border-solid border-neutrals-neutral-100">
                <div className="relative font-semibold">
                  Customisable reports
                </div>
              </div>
              <div
                className="w-[400px] shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-neutrals-neutral-50 box-border flex flex-row items-center justify-start p-5 gap-[10px] cursor-pointer text-base border-[1px] border-solid border-neutrals-neutral-100"
                onClick={openCustomiseReport}
              >
                <div className="rounded-3xs bg-primary-primary-500 flex flex-row items-start justify-start p-3">
                  <img
                    className="w-6 relative h-6"
                    alt=""
                    src="assets/document.svg"
                    style={{ filter: "brightness(0) invert(1)" }}
                  />
                </div>
                <div className="flex-1 flex flex-col items-start justify-start gap-[6px]">
                  <div className="self-stretch relative font-semibold">
                    Generate your report
                  </div>
                  <div className="self-stretch relative text-sm text-neutrals-neutral-300">
                    Craft your comprehensive report with ease
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
      {isCustomiseReportOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeCustomiseReport}
        >
          <CustomiseReport onClose={closeCustomiseReport} />
        </PortalPopup>
      )}
      {isExportModalImageOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeExportModalImage}
        >
          <ExportModalImage onClose={closeExportModalImage} />
        </PortalPopup>
      )}
      {isLogoutConfirmationOpen && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeLogoutConfirmation}
        >
          <LogoutConfirmation onClose={closeLogoutConfirmation} />
        </PortalPopup>
      )}
      {isExportModalImage1Open && (
        <PortalPopup
          overlayColor="rgba(113, 113, 113, 0.3)"
          placement="Centered"
          onOutsideClick={closeExportModalImage1}
        >
          <ExportModalImage onClose={closeExportModalImage1} />
        </PortalPopup>
      )}
    </>
  );
};

export default OutcomesAndCostsPage_5;
